import React from 'react'
import BreadCrumb from '../../../Common/BreadCrumb'
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

const FlatPickr = () => {

    return (
        <React.Fragment>
            <BreadCrumb title="Flatpickr" pageType="Sliced" />

            <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <div className="card">
                        <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">Basic Example</h2>
                        <form className="space-y-4" >
                            <Flatpickr
                                className="form-input"
                                id="basicExample"
                            />
                        </form>
                    </div>
                    <div className="card">
                        <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">Example</h2>
                        <form className="space-y-4" >
                            <Flatpickr
                                className="form-input"
                                id="basicExample"
                            />
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default FlatPickr